import { BillingGroup, GUID } from '@ndvr/billing-api';

import { Button } from '@/components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';
import { pluralize } from '@/utils/string-utils';

type SkippedGroupResult = {
    billingGroupGUID: GUID<BillingGroup>;
    billingGroupName: string;
    reason: string;
};

export type RerunResult = {
    rerunCount: number;
    skippedGroups: SkippedGroupResult[];
};

type RerunResultDialogProps = {
    result?: RerunResult;
    onClose: () => void;
};

export const RerunResultDialog = ({ result, onClose }: RerunResultDialogProps) => {
    if (!result) return null;

    const skipped = pluralize(result.skippedGroups.length, 'billing group');
    const title = result.rerunCount ? 'Rerun Completed with Skips' : 'Billing Groups Not Rerun';
    const description = result.rerunCount
        ? `Rerun completed for ${pluralize(result.rerunCount, 'billing group')}. Skipped ${skipped}.`
        : `Skipped ${skipped}.`;

    return (
        <Dialog open onOpenChange={(open) => !open && onClose()}>
            <DialogContent className="sm:max-w-[500px]">
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                    <DialogDescription>{description}</DialogDescription>
                </DialogHeader>
                <div className="max-h-72 space-y-2 overflow-y-auto">
                    {result.skippedGroups.map((group) => (
                        <div key={group.billingGroupGUID} className="rounded-md border border-gray-200 p-3">
                            <div className="text-sm font-medium text-gray-900">{group.billingGroupName}</div>
                            <div className="text-muted-foreground mt-0.5 text-sm">{group.reason}</div>
                        </div>
                    ))}
                </div>
                <DialogFooter>
                    <Button onClick={onClose}>Close</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
